<template>
  <div>
      <div className="TVChartContainer" ref="chartContainer"/>
  </div>
</template>

<script>
import Datafeed from "../TV/datafeed";
import {widget} from '../public/charting_library';

export default {
  name: 'TradingviewChart',
  props: {
    interval: {
      default: 'h',
      type: String
    },
    containerId: {
      default: 'tv_chart_container',
      type: String
    },
    libraryPath: {
      default: '/charting_library/',
      type: String
    },
    chartsStorageUrl: {
      default: 'https://arzypto.com/api/chart',
      type: String
    },
    chartsStorageApiVersion: {
      default: '1.1',
      type: String
    },
    clientId: {
      default: 'https://www.arzypto.com',
      type: String
    },
    userId: {
      default: '1',
      type: String
    }
  },
  data () {
    return {
      forInsert: null,
      loading: false,
      source: 'PANEL', // ANDROID, PANEL, WEBAPP
      type: 'ARZYPTO', // ARZYPTO_EXCHANGE, ARZYPTO, GLOBAL
      exchanger: 'BINANCE', // BINANCE, COINEX: use in global chart
      pair: 'USDT_TMN',
      from: null,
      to: null
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search)
    this.type = urlParams.get('type')
    this.pair = urlParams.get('pair')
    this.source = urlParams.get('source')
    if(this.type === 'ARZYPTO' || this.type == 'ARZYPTO_EXCHANGE') {
      this.renderArzyptoChart()
    }
  },
  methods: {
    renderArzyptoChart () {
      const widgetOptions = {
        symbol: 'Arzypto:' + this.pair.replace(/_/g, '/'),
        datafeed: Datafeed,
        interval: this.interval,
        container: this.$refs.chartContainer,
        library_path: this.libraryPath,
        locale: 'fa',
        charts_storage_url: this.chartsStorageUrl,
        charts_storage_api_version: this.chartsStorageApiVersion,
        enabled_features: [],
        disabled_features: [],
        client_id: this.clientId,
        user_id: this.userId,
        fullscreen: true,
        autosize: true,
        theme: 'light',
        allow_symbol_change: true,
        initialVisibleBars: 19,
        timezone: 'َUTC', 
        customFormatters: {
          timeFormatter: {
            format: (date) => {
              return date.toLocaleTimeString("fa-IR", { hour: "2-digit", minute:  "2-digit"})
            }
          },
          dateFormatter: {
            format: function (date) {
              return date.toLocaleDateString('fa-IR')
            }
          },
          "SHIB_IRT": {
            minMove: 0.01,
            precision: 3
          },
        }
      }

      if(this.source == 'ANDROID' || this.source == 'WEBAPP') {
        const disableList = ['header_widget', 'left_toolbar', 'timeframes_toolbar', 'border_around_the_chart']
        widgetOptions.disabled_features = widgetOptions.disabled_features.concat(disableList)
      }

      this.tvWidget = new widget(widgetOptions)
    }
  }
}
</script>
